import { defineMessages, useIntl } from 'react-intl';

import { Link, LinkVariant, RenderType, TicketExchangeIcon } from '@jsmdg/yoshi';
import { trackAlternativeExperienceLinkClicked } from './alternativeExperienceLink.tracking';

const messages = defineMessages({
    alternativeExperienceLink: {
        defaultMessage: 'Lieber ein anderes Erlebnis? Such dir hier was raus.',
    },
});

const AlternativeExperienceLink = (): JSX.Element => {
    const intl = useIntl();
    const alternativeExperienceLinkText = intl.formatMessage(messages.alternativeExperienceLink);

    return (
        <div className="mt-2x mt-sm-3x w-100">
            <Link
                as={RenderType.Link}
                variant={LinkVariant.Brand}
                iconLeft={<TicketExchangeIcon className="mr-0-5x" />}
                href="/alle-erlebnisse/l/79ifa"
                onClick={e => {
                    trackAlternativeExperienceLinkClicked(
                        alternativeExperienceLinkText,
                        e.currentTarget.href,
                    );
                }}
            >
                {alternativeExperienceLinkText}
            </Link>
        </div>
    );
};

export { AlternativeExperienceLink };
